module.exports = __webpack_public_path__ + "static/media/1001540TL.3630c875.jpg";